/* Revyvy Part 2: stand picker (panel + stand in one /cart/add.js call, then Impact's cart-drawer refresh),
   count-up figures, coverage toggle, body map, simple tab groups. No dependencies. */
(() => {
  const root = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  if (!customElements.get('rv-stand-picker')) customElements.define('rv-stand-picker', class extends HTMLElement {
    connectedCallback() {
      this._onSubmit = this._onSubmit.bind(this);
      document.addEventListener('submit', this._onSubmit, true);
    }
    disconnectedCallback() { document.removeEventListener('submit', this._onSubmit, true); }
    get form() {
      return document.getElementById(this.dataset.form) || this.closest('.shopify-section')?.querySelector('form[action*="/cart/add"]');
    }
    get standId() {
      const r = this.querySelector('input[type="radio"]:checked');
      return r && r.value ? parseInt(r.value, 10) : null;
    }
    async _onSubmit(event) {
      const form = this.form;
      if (!form || event.target !== form || !this.standId) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      event.stopPropagation();
      const data = new FormData(form);
      const qty = Math.max(1, parseInt(data.get('quantity') || '1', 10) || 1);
      const buttons = document.querySelectorAll(`button[type="submit"][form="${form.id}"], #${CSS.escape(form.id)} button[type="submit"]`);
      buttons.forEach((b) => b.setAttribute('aria-busy', 'true'));
      const bundle = new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: [] } });
      document.documentElement.dispatchEvent(bundle);
      let response, json;
      try {
        response = await fetch(`${root()}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({
            items: [{ id: parseInt(data.get('id'), 10), quantity: qty }, { id: this.standId, quantity: qty }],
            sections: bundle.detail.sections.join(',')
          })
        });
        json = await response.json();
      } finally {
        buttons.forEach((b) => b.removeAttribute('aria-busy'));
      }
      if (!response.ok) {
        form.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { error: json && json.description } }));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        return;
      }
      const settings = (window.themeVariables && window.themeVariables.settings) || {};
      if (settings.cartType === 'page' || settings.pageType === 'cart') { window.location.href = `${root()}cart`; return; }
      const cart = await (await fetch(`${root()}cart.js`)).json();
      cart.sections = json.sections || {};
      form.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: json.items || [], cart } }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart } }));
    }
  });

  /* Count-up for plain integers (with optional ">" and thousands separators). Static for anything else. */
  const counters = document.querySelectorAll('[data-rv-count]');
  if (counters.length && 'IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        const el = entry.target, text = el.dataset.rvCount, m = text.match(/^(>?)([\d,]+)$/);
        if (!m) return;
        const target = parseInt(m[2].replace(/,/g, ''), 10), start = performance.now(), dur = 1400;
        const fmt = (n) => m[1] + n.toLocaleString('en-US');
        const step = (t) => {
          const p = Math.min(1, (t - start) / dur), e = 1 - Math.pow(1 - p, 3);
          el.textContent = fmt(Math.round(target * e));
          if (p < 1) requestAnimationFrame(step); else el.textContent = text;
        };
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    counters.forEach((c) => io.observe(c));
  }

  /* Tab groups: [data-rv-tabs] containing [role=tab][aria-controls] and [role=tabpanel]. Used by coverage, body map. */
  document.querySelectorAll('[data-rv-tabs]').forEach((group) => {
    const tabs = group.querySelectorAll('[role="tab"]');
    tabs.forEach((tab) => tab.addEventListener('click', () => {
      const id = tab.getAttribute('aria-controls');
      tabs.forEach((t) => t.setAttribute('aria-selected', String(t.getAttribute('aria-controls') === id)));
      group.querySelectorAll('[role="tabpanel"]').forEach((p) => { p.hidden = p.id !== id; });
    }));
  });
})();